import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames'

import { ListItem, Flex, Loading } from '~/views'

import style from './style.css'

const ICONS = {
  TRACE : <i className="fa fa-asterisk" />,
  INFO : <i className="fa fa-info" />,
  DEBUG : <i className="fa fa-bug" />,
  WARN : <i className="fa fa-exclamation" />,
  ERROR : <i className="fa fa-times" />,
  FATAL : <i className="fa fa-bolt" />,
  NOTICE : <i className={classnames( 'fa fa-comment', style.textTop )} />
}

export default class ScriptItem extends React.Component {

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func.isRequired
  }

  renderLeft() {
    return null
  }

  renderRight( scriptLog ) {
    let parsedLog = scriptLog.data
    if ( typeof parsedLog === 'object' ) {
      parsedLog = JSON.stringify( scriptLog.data, null, 2 )
    }
    return (
      <Flex direction="row">
        <div>
          <pre>
            {parsedLog}
          </pre>
          {scriptLog.trace}
        </div>
      </Flex>
    )
  }

  render() {
    const { item : scriptLog, onEvent } = this.props;
    if ( scriptLog.type === 'loadMore' ) {
      return (
        <ListItem
          className={style.scriptItem} 
          onEvent={event => onEvent( scriptLog, event )}
          item={scriptLog}
          title={(
            <div className={style.center}>
              <i className={classnames( 'fa fa-plus', style.loadMore )} />
              {' '}
              Load More Logs
              {' '}
            </div>
          )} />
      )
    } if ( scriptLog.type === 'loadingMore' ) {
      return (
        <ListItem
          className={style.scriptItem} 
          onEvent={event => onEvent( scriptLog, event )}
          item={scriptLog}
          title={<Loading show className={style.center} />} />
      )
    }
    const icon = ICONS[scriptLog.severity && scriptLog.severity.toUpperCase()] || ICONS.INFO
    return (
      <ListItem
        className={style.scriptItem} 
        onEvent={this.onEvent}
        item={scriptLog}
        title={(
          <Flex align="center" justify="flex-start">
            <div className={style.icon}>
              {icon}
            </div>
            {scriptLog.severity}
          </Flex>
        )}
        subtitle={scriptLog.timestamp}
        leftView={this.renderLeft( scriptLog )}
        rightView={this.renderRight( scriptLog )} />
    )
  }
}
